import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Box,
  Checkbox,
  FormControlLabel,
  IconButton,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { useFormik } from "formik";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import LoginBackground from "../../../assets/images/loginBackground.svg";
import CommonButton from "../../../component/Button";
import SnackBar from "../../../component/SnackBar";
import { LoginCall, PlanExpiredCall, SetLocalStorage } from "../../../redux/action/Login";
import { CustomDiv } from "../../chat-bot/style";
import {
  CommonGrid2,
  StyledFlexColumnView,
} from "../../common-components/StyledComponents";
import { trackLogin } from "../../mixpanel/mixpanel";
import { CustomizeSpan } from "../../jobs/style";
import { useDispatch } from "react-redux";
import {platformWhiteLogo} from "../../../utils/logo";

// import { CustomizeSpan } from "../../../../../modules/jobs/style";

const validationSchema = Yup.object({
  email: Yup.string().required("This field is required"),
  password: Yup.string().required("Password is required"),
  // rememberMe: Yup.boolean().oneOf([true], "You must agree to remember me."),
});

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [buttonLoading, setButtonLoading] = useState(false);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const theme = useTheme();
const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      rememberMe: false,
    },
    validationSchema,
    onSubmit: async (values, form) => {
      setButtonLoading(true);
      let payload = {
        username: values.email,
        password: values.password,
      };
      try {
        const data = await LoginCall(payload);
        window.localStorage.setItem("credential", JSON.stringify(data));

        // Track successful login in Mixpanel
        trackLogin({
          user_id: data.user_id,
          username: data.username || values.email,
        });

        const planData = await PlanExpiredCall(data.organization_id);
        let overallData = {
          ...data,
          ...planData,
        };
        dispatch(
          SetLocalStorage({
            data: overallData,
          })
        );
        window.localStorage.setItem("credential", JSON.stringify(overallData));
        setSnackbarState({
          open: true,
          severity: "success",
          message: "Login Successfull",
        });
        setButtonLoading(false);
        if (!planData.active) {
          navigate("/plan-expired");
        } else if (!data.is_onboarding_completed) {
          navigate("/onboarding");
        } else if (planData?.subscription_details?.credits_remaining <= 0) {
          navigate("/buy-credits");
        } else navigate("/home");
      } catch (error) {
        setButtonLoading(false);
        setSnackbarState({
          open: true,
          severity: "error",
          message: error?.message || "Something went wrong",
        });
      }
      // if (values.email !== "talario@gmail.com") {
      //   form.setFieldError("email", "Enter a valid email address");
      // }
      // if (values.password !== "talario@123") {
      //   form.setFieldError("password", "The password is incorrect");
      // } else {
      //   // const data =await Login()
      //   navigate("/dashboard");
      // }
    },
  });

  // useEffect(() => {
  //   const data = JSON.parse(localStorage.getItem("credential"));
  //   if (!!data) {
  //     navigate("/home");
  //   }
  // }, []);

  const handleShowPasswordToggle = () => setShowPassword((prev) => !prev);

  const renderTextField = (name, label, type = "text", placeholder) => (
    <StyledFlexColumnView gap="8px">
      <Typography
        fontWeight={600}
        color={
          formik.touched[name] && formik.errors[name] ? "#d32f2f" : "#5B738B"
        }
      >
        {label}
        <CustomizeSpan color={"red"}> *</CustomizeSpan>
      </Typography>
      <div>
        <TextField
          size="small"
          type={
            type === "password" ? (showPassword ? "text" : "password") : "text"
          }
          fullWidth
          id={"login_" + name}
          placeholder={placeholder}
          value={formik.values[name]}
          onChange={(e) => formik.setFieldValue(name, e.target.value)}
          error={formik.touched[name] && Boolean(formik.errors[name])}
          InputProps={{
            endAdornment: name === "password" && (
              <IconButton onClick={handleShowPasswordToggle} edge="end">
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            ),
          }}
          sx={{
            backgroundColor: "#EBF1F4",
            "& .Mui-error": { border: "2px solid #d32f2f" },
            "& fieldset": { border: "none" },
            borderRadius: "5px",
            height: "40px",
          }}
        />
        {formik.touched[name] && formik.errors[name] && (
          <Typography
            color="error"
            fontSize="11px"
            marginTop="5px"
            fontWeight={600}
          >
            {formik.errors[name]}
          </Typography>
        )}
      </div>
    </StyledFlexColumnView>
  );

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  return (
    <CustomDiv
      sx={{
        backgroundImage: `url(${LoginBackground})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Box
        maxWidth={"550px"}
        margin={"auto"}
        display="flex"
        flexDirection={"column"}
        alignItems={"center"}
        flexGrow={1}
        justifyContent={"center"}
        minHeight={"100vh"}
        paddingX={{
          xs: "16px",
          sm: "32px",
        }}
      >
        <CustomDiv margin="0px 0px 2rem">
          {/* <SliderTalairoIco width="160px" height={"55px"} /> */}
          {platformWhiteLogo({ width: "180", height: "60" })}
        </CustomDiv>
        <CustomDiv
          width="100%"
          borderRadius="15px"
          boxShadow="0px 4px 20px rgba(0, 0, 0, 0.1)"
          background="#fff"
        >
          <form onSubmit={formik.handleSubmit}>
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              height="100%"
              padding="40px 40px 20px 40px"
              gap="12px"
              sx={{
                [theme.breakpoints.down("sm")]: {
                  padding: "15px",
                },
                [theme.breakpoints.up("sm")]: {
                  padding: "40px 40px 20px 40px",
                },
              }}
            >
              <Typography
                textAlign="center"
                fontWeight={700}
                fontSize="32px"
                color="#223548"
              >
                Welcome Back!
              </Typography>
              <Typography textAlign="center" color="#5B738B">
                Login to your account
              </Typography>

              {renderTextField(
                "email",
                "User name or Email ID",
                "text",
                "Enter user name or Email ID"
              )}
              {renderTextField(
                "password",
                "Password",
                "password",
                "Enter your Password"
              )}

              <CommonGrid2
                alignItems={"center"}
                marginTop={"0.5rem"}
                display={"flex"}
                justifyContent={"space-between"}
              >
                <CommonGrid2>
                  <FormControlLabel
                    sx={{
                      color:
                        formik.touched.rememberMe &&
                        formik.errors.rememberMe &&
                        "#d32f2f",
                    }}
                    control={
                      <Checkbox
                        checked={formik.values.rememberMe}
                        onChange={(e) =>
                          formik.setFieldValue("rememberMe", e.target.checked)
                        }
                      />
                    }
                    label="Remember me"
                  />

                  {formik.touched.rememberMe && formik.errors.rememberMe && (
                    <Typography
                      color="error"
                      fontSize="11px"
                      marginTop="-0.5rem"
                      fontWeight={600}
                    >
                      {formik.errors.rememberMe}
                    </Typography>
                  )}
                </CommonGrid2>
                <Typography
                  variant="caption"
                  color="primary"
                  fontWeight={600}
                  sx={{
                    cursor: buttonLoading ? "auto" : "pointer",
                    opacity: buttonLoading ? 0.3 : 1,
                  }}
                  onClick={() =>
                    buttonLoading ? {} : navigate("/auth/forgot-password")
                  }
                >
                  Forgot Password?
                </Typography>
              </CommonGrid2>

              <CommonButton
                type="submit"
                value="Login"
                padding="10px 16px"
                borderRadius="6px"
                loading={buttonLoading}
                disabled={buttonLoading}
              />

              {/* <Divider>
            <Typography color={"#8396A8"}>or</Typography>
          </Divider>

          <Button
            size="small"
            variant="outlined"
            fullWidth
            sx={{
              borderColor: "#D5DADD",
              color: "#1A2733",
              fontWeight: 600,
              opacity: "0.7",
            }}
            disabled
            startIcon={<img src={GoogleLogo} alt="Google Logo" />}
          >
            Login with Google
          </Button> */}

              <CommonGrid2
                display={"flex"}
                gap={"10px"}
                justifyContent={"center"}
                marginTop={"10px"}
              >
                <Typography variant="caption" color="text.secondary">
                  {"Don’t have an account ?"}
                </Typography>
                <Typography
                  variant="caption"
                  color="primary"
                  sx={{
                    cursor: buttonLoading ? "auto" : "pointer",
                    opacity: buttonLoading ? 0.3 : 1,
                  }}
                  fontWeight={600}
                  onClick={() =>
                    buttonLoading ? {} : navigate("/auth/sign-up")
                  }
                >
                  {"Sign up for Free"}
                </Typography>
              </CommonGrid2>
            </Box>
          </form>
          <SnackBar
            snackbarState={snackbarState}
            handleCloseValidation={handleCloseValidation}
          />
        </CustomDiv>
      </Box>
    </CustomDiv>
  );
};

export default Login;
